export default "__VITE_ASSET__DFuCmDdU__"